<template>
    <v-btn
        v-bind="$attrs"
        text
        :loading="loading"
        :color="color"
        small
        @click="$emit('click', $event)"
    >
        <icon
            v-if="icon"
            size="16"
            :icon="icon"
        />
        <div class="caption ml-2 text-none">
            <slot />
        </div>

    </v-btn>
</template>

<script>
export default {
    name: "SecondaryButton",
    props: {
        icon: {
            type: String,
            default: null
        },
        color: {
            type: String,
            default: "n3"
        },
        loading: {
            type: Boolean,
            default: false
        }
    }
}
</script>
